<template>
  <div class="login-body">
    <Toast />
    <div class="login-image"></div>
    <div class="card login-panel p-fluid">
      <div class="login-panel-content">
        <div class="p-grid">
          <div class="p-col-3" style="text-align:left">
            <img src="img/Logo-HTP-Circle.png" height="90px" alt="avalon-vue"/>
          </div>
          <div class="p-col-9" style="text-align:left">
            <h2 class="welcome-text">Password Reset</h2>
            <span class="guest-sign-in">Set new password for your TIMS account</span>
          </div>
          <div class="p-col-12" style="text-align:left">
            <label class="login-label">New Password</label>
            <div class="login-input">
              <Password v-model="input.password.value" placeholder="New Password" name="password" :toggleMask="true" :feedback="false" v-bind:class="{ 'p-error': input.password.errMsg }" :required="true" />
              <small v-if="input.password.errMsg" class="p-error">{{ input.password.errMsg }}</small>
            </div>
          </div>
          <div class="p-col-12" style="text-align:left">
            <label class="login-label">Confirm New Password</label>
            <div class="login-input">
              <Password v-model="input.confirm_password.value" placeholder="Confirm New Password" name="confirm_password" :toggleMask="true" :feedback="false" v-bind:class="{ 'p-error': input.confirm_password.errMsg }" :required="true" />
              <small v-if="input.confirm_password.errMsg" class="p-error">{{ input.confirm_password.errMsg }}</small>
            </div>
          </div>
          <div class="p-col-12 p-md-6 button-pane">
            <Button v-if="isSubmit" label="Submitting . . ." :disabled="true" />
            <Button v-else label="Submit" @click="onSubmit"/>
          </div>
          <div class="p-col-12 p-md-6 link-pane">
            <router-link :to="{ name: 'login' }"><button class="p-link">Back to login</button></router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reset } from "@/api/auth.js"

export default {
  name: "ResetPassword",

  data() {
    return {
      isSubmit: false,
      input: {
        password: {
          value: '',
          errMsg: null
        },
        confirm_password: {
          value: '',
          errMsg: null
        }
      },
      resetObj: {
        token: this.$route.params.token,
        new_password: null,
      }
    }
  },
  methods: {
    goDashboard() {
      window.location = "app"
    },
    onSubmit() {
      // Form Validation
      let doSubmit = true
      this.input.password.errMsg = null
      this.input.confirm_password.errMsg = null

      if (this.input.password.value == "" || this.input.password.value == null) {
        doSubmit = false
        this.input.password.errMsg = "New Password must not be empty"
      }

      if (this.input.confirm_password.value == "" || this.input.confirm_password.value == null) {
        doSubmit = false
        this.input.confirm_password.errMsg = "Confirm New Password must not be empty"
      } else if (this.input.password.value != this.input.confirm_password.value) {
        doSubmit = false
        this.input.confirm_password.errMsg = "Confirm New Password must match with New Password"
      }

      this.resetObj.new_password = this.input.password.value

      // Submit
      if (doSubmit) {
        this.isSubmit = true

        try {
          reset(this.resetObj)
            .then((res) => {
              if (res.data.status) {
                this.$toast.add({severity:'success', summary: 'Success', detail: res.data.message, life: 5000})
                this.$session.flash.set("flash-class", "success")
                this.$session.flash.set("flash-message", "Password changed successfully")

                this.$router.push({ name: "login" })
              } else {
                this.$toast.add({severity:'error', summary: 'Error', detail: res.data.message, life: 5000})
              }
            })
            .finally(() => { this.isSubmit = false })
            .catch((e) => {
              if(e.response.status && e.response.status == 422) {
                this.$toast.add({severity:'error', summary: 'Error', detail: e.response.data.message, life: 5000})

                if(e.response.data.errors) {
                  let errObj = e.response.data.errors
                  this.input.password.errMsg = errObj.password ? errObj.password[0] : null
                  this.input.confirm_password.errMsg = errObj.confirm_password ? errObj.confirm_password[0] : null
                }
              } else {
                this.$toast.add({severity:'error', summary: 'Error', detail: "Password failed to changed due to network error.", life: 5000})
              }
            })
        } catch (e) {
          console.error(e)
        }
      }
    }
  }
}
</script>

<style scoped>

</style>